import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'wtb-components/theme';

import { LocaleProvider } from 'context';
import mainTheme from 'themes/main';

import './i18n';
import './index.css';
import App from './App';

Sentry.init({
  dsn: 'https://5cbae0eca7384434b7707729b21f7152@o1279236.ingest.sentry.io/6479666',
  environment: import.meta.env.MODE,
  attachStacktrace: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.breadcrumbsIntegration({ console: false })
  ],
  beforeSend: (event) => (import.meta.env.PROD ? event : null),
  denyUrls: [
    /extensions\//i,
    /^chrome:\/\//i
  ],
  tracesSampleRate: 1.0
});

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider className="theme-root" theme={mainTheme}>
        <LocaleProvider>
          <App />
        </LocaleProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
